<template>
    <el-dialog :visible.sync="dialogVisible" @close="closeDialog" :close-on-click-modal="false" :title="title" class="dialog-large">
        <div class="codeMessage">
            <p>{{ $STR('TRACING.traceQeury.codeInfo', '码值信息') }}</p>
            <el-table :empty-text="$STR('COMMON.data.empty', '暂无数据')" :data="codeList" highlight-current-row :row-style="{height: '0'}" :cell-style="{padding: '0'}">
                <el-table-column :label="$STR('CODE.codeDetails.code', '码类')" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{scope.row.codeInfo ? scope.row.codeInfo.categoryName : ''}}
                    </template>
                </el-table-column>
                <el-table-column :label="$STR('ws_title_warehouse_operation_message_code_value', '码值')" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{filterCode(scope.row.codeInfo.codes)}}
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="current"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="count">
            </el-pagination>
        </div>
    </el-dialog>
</template>
<script>
import qs from 'qs';

export default {
    props: ['visible', 'detailParams', 'whichOne', 'oneLevelFlag'],
    computed: {
        dialogVisible: {
            get: function () { return this.visible; },
            set: function () { return; }
        },
        title: {
            get: function () {
                let titleMap = {'out': this.$STR('WAREHOUSE.out.stock.detail', '出库详情'), 'in': this.$STR('WAREHOUSE.in.stock.detail', '入库详情')};
                return titleMap[this.whichOne];
            },
            set: function () { return; }
        }
    },
    watch: {
        visible (val) {
            if (!val) return;
            this.getDetail(); //获取详情信息
        }
    },
    data () {
        return {
            codeList: [],
            current: 1,
            rows: 20,
            count: 0,
            selectStatistics: {} //当前详情
        };
    },
    created () {
    },
    methods: {
        filterCode (codes) {
            return commonRequest.filterCode(codes);
        },
        // 关闭弹窗
        closeDialog () {
            this.$parent.detailDialogVisible = false;
        },
        handleSizeChange(val) { //分页
            this.rows = val;
            this.getDetail();
        },
        handleCurrentChange(val) { //分页
            this.getDetail(val);
        },
        getDetail (val = 1) { //获取详情信息
            this.current = val;
            this.detailParams.pageIndex = this.current;
            this.detailParams.pageSize = this.rows;
            this.codeList = [];
            this.$http.get(WebApi.warehouse.getStockOutInDetails, {
                params: this.detailParams,
                paramsSerializer: params => { return qs.stringify(params, { indices: false }); }
            }).then(res => {
                if (res.data) {
                    if (res.data.resultCode === '0') {
                        this.selectStatistics = res.data.data ? res.data.data : {}; //数据解析
                        this.codeList = this.selectStatistics.codeList ? this.selectStatistics.codeList : [];
                        this.count = this.selectStatistics.count;
                    } else {
                        this.$message({ showClose: true, message: this.$STR(response.data.resultCode, response.data.message), type: 'error' });
                    }
                }
            });
        }
    }
};
</script>
<style scoped>
    .codeShowDetail{
        padding-bottom: 10px;
        border: 1px solid #f4f4f4;
    }
    .codeShowDetail p{
        padding: 5px 10px 5px 10px;
        border: solid #f4f4f4;
        border-width: 0 1px 1px 0;
        display: flex;
    }
    .codeTotal {
        display: flex;
    }
    .codeTotal div {
        width: 50%;
        height: 30px;
        border-bottom: solid #f4f4f4;
        border-width: 0 1px 1px 0;
    }
    .codeShowDetail span{
        font-size: 14px;
        line-height: 30px;
        color: rgb(110,110,110);
        overflow-wrap: break-word;
        margin-left: 30px;
    }
    .codeShowDetail .blue-text {
        color: #4a8df0;
    }
    .codeMessage{
        margin-bottom: 20px;
        border: 1px solid #f4f4f4;
        width: 100%;
        overflow-y: auto
    }
    .codeMessage p{
        font-size: 13px;
        padding: 7px 10px 7px 10px;
        border: solid #f4f4f4;
        border-width: 0 1px 1px 0;
        background-color: #f4f4f4;
        color: rgb(51, 51, 51)
    }
    .codeMessage span{
        font-size: 13px;
        color: rgb(110,110,110);
        overflow-wrap: break-word;
        margin-left: 30px;
        line-height:2px;
    }
</style>



// WEBPACK FOOTER //
// src/views/cloud/warehouse/stockDetail.vue